// Order matters (docs/ui-components.md): kit tokens, base, components, then the
// library CSS, then the bridge that maps --bo-* onto the kit tokens.
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import '@bennows/boows-react/style.css';
import './styles/boows-bridge.css';
import './styles/project.css';
import './styles/project-data-table.css';
import './styles/project-shell.css';
import './styles/project-phone-frame.css';
import './styles/project-page-header.css';
import './styles/project-segmented.css';
import './styles/project-tabs.css';
import './styles/project-app-brand.css';
import './styles/project-media.css';
import './styles/project-content.css';
import './styles/project-knowledge.css';
import './styles/project-content-workspace.css';
import './styles/project-content-post.css';
import './styles/project-content-tags.css';
import './styles/project-content-mentions.css';
import './styles/project-brand.css';
import './styles/project-editor.css';
import './styles/project-ai.css';
import './styles/project-review.css';
import './styles/project-finding-message.css';
import './styles/project-start-phone.css';
import './styles/project-inbox-report.css';
import './styles/project-review-panels.css';
import './styles/project-preview.css';
import './styles/project-calendar.css';
import './styles/project-calendar-phone.css';
import './styles/project-calendar-cards.css';
import './styles/project-post-card.css';
import './styles/project-entries.css';
import './styles/project-charts.css';
import './styles/project-calendar-campaigns.css';
import './styles/project-notifications.css';
import './styles/project-accounts.css';
import './styles/project-publications.css';
import './styles/project-search.css';
import './styles/project-reels.css';
import './styles/project-reels-motion.css';
import './styles/project-voice.css';
import './styles/project-voice-visual.css';
import './styles/project-website-import.css';
import './styles/project-inbox.css';
import './styles/project-planning.css';
import './styles/project-planning-grid.css';
import './styles/project-dashboard.css';
import './styles/project-dashboard-overview.css';
import './styles/project-start-overview.css';
import './styles/project-start.css';
import './styles/project-analytics.css';
import './styles/project-analytics-chart.css';
import './styles/project-controls.css';
import './styles/project-integrations.css';
import './styles/project-landing.css';
import './styles/project-landing-showcase.css';
import './styles/project-landing-month.css';
import './styles/project-landing-plans.css';
import './styles/project-landing-explainer-scenes.css';
// After the scenes: its phone layout overrides them.
import './styles/project-landing-explainer.css';
import './styles/project-landing-explainer-motion.css';
import './styles/project-auth.css';
import './styles/project-feedback.css';
import './styles/project-assistant.css';

// S130-1 (style guide 0a): Outfit only, like augo-suite - no second UI face.
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
// Roboto 400 only for the Google Maps attribution (Google's text-attribution rule, style guide 2.75).
import '@fontsource/roboto/400.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { captureInstallPrompt } from './features/install/install-prompt';
import { initI18n } from './i18n';
import { initAnalytics } from './lib/analytics';

initI18n();
captureInstallPrompt();
initAnalytics();
const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
